var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullScreen",on:{"click":_vm.fullScreenClick}},[_c('img',{class:{ active: _vm.fullScreen },attrs:{"type":_vm.fullScreen? 'primary' : '',"src":require("../../assets/img/apicture/fullscreen.png")}}),_c('span',[_vm._v(_vm._s(_vm.fullScreen ? '退出全屏' : '全屏'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }